import { InlineEdit, type InlineEditProps } from '@affine/component';
import { DocsService, useLiveData, useService, WorkspaceService, } from '@toeverything/infra';
import clsx from 'clsx';
import type { HTMLAttributes } from 'react';
import { useEffect, useRef } from 'react'

import * as styles from './style.css';
import { documentTemplatesListQuery, updateDocumentTemplateMutation } from "@affine/graphql";
import { GraphQLService } from "@affine/core/modules/cloud";

export interface BlockSuiteHeaderTitleProps {
  docId: string;
  /** if set, title cannot be edited */
  inputHandleRef?: InlineEditProps['handleRef'];
  className?: string;
}

const inputAttrs = {
  'data-testid': 'title-content',
} as HTMLAttributes<HTMLInputElement>;

/**
 * 这个组件为编写文档时的左上角的小标题组件
 */
export const BlocksuiteHeaderTitle = (props: BlockSuiteHeaderTitleProps) => {
  const { inputHandleRef, docId } = props;
  const workspaceService = useService(WorkspaceService);
  const workspace = useService(WorkspaceService).workspace;
  const isSharedMode = workspaceService.workspace.openOptions.isSharedMode;
  const docsService = useService(DocsService);

  const docRecord = useLiveData(docsService.list.doc$(docId));
  const docTitle = useLiveData(docRecord?.title$);
  // const pageMetas = useBlockSuiteDocMeta(workspace.docCollection);
  // const filterPageMetas = useFilteredPageMetas(pageMetas, {
  //   filters: []
  // });

  // 修改文档名称
  // const updateDocTitle = async e => {
  //   const inputValue = e.target.value
  //   const allTitleList = filterPageMetas.filter(r => r.id !== docId).map(r => r.title)
  //   const uniqueTitle = generateUniqueTitle(allTitleList, inputValue.trim());
  //   await docsService.changeDocTitle(docId, uniqueTitle);
  //   inputHandleRef.current?.setEditingValue?.(uniqueTitle);
  //   track.$.header.actions.renameDoc();
  // }

  const saveTitleTemplate = () => {
    if (activeDocTemplateData.current) {
      graphqlService.gql({
        query: updateDocumentTemplateMutation,
        variables: {
          input: {
            name: docTitle ?? activeDocTemplateData.current.name,
            documentId: docId,
            id: activeDocTemplateData.current?.id,
            workspaceId: workspace.id,
          }
        }
      })
    }
  }

  const graphqlService = useService(GraphQLService);
  const activeDocTemplateData = useRef()
  const getDetail = id => {
    graphqlService.gql({
      query: documentTemplatesListQuery,
      variables: {
        input: {
          page: 1,
          pageSize: 999,
          filter: {
            documentId: id,
            workspaceId: workspace.id
          }
        }
      }
    }).then(res => {
      const total = res.documentTemplates.total
      if (total === 1) {
        console.log('当前文档是模板文档', res.documentTemplates.list[0])
        activeDocTemplateData.current = res.documentTemplates.list[0]
      }
    })
  }
  useEffect(() => {
    getDetail(docId)
  }, []);

  // 标题变化实时监听
  useEffect(() => {
    let time = setTimeout(saveTitleTemplate, 500)
    return () => {
      if (time) {
        clearTimeout(time)
        time = undefined
      }
    }
  }, [docTitle]);

  return (
    <>
      <InlineEdit
        className={clsx(styles.title, props.className)}
        value={docTitle}
        editable={!isSharedMode}
        exitible={true}
        placeholder="未命名"
        data-testid="title-edit-button"
        handleRef={inputHandleRef}
        inputAttrs={inputAttrs}
      />
    </>
  );
};
